const countries = require("./countries");
const currencies = require("./currencies");
const plans = require("./plans");

module.exports = Object.assign({}, countries, currencies, plans);
